import { SxProps, Theme } from '@mui/material';

export const COLOR_DOT_SIZE = 33;
export const COLOR_DOT_GAP = 8;
const COLOR_DOT_INNER_SIZE = 27;

export const colorDotsOuterSX = (sx?: SxProps<Theme>): SxProps<Theme> => ({
	width: '100%',
	minWidth: 0,
	overflow: 'hidden',
	contain: 'inline-size',
	...sx,
});

export const colorDotsRowSX: SxProps<Theme> = {
	display: 'flex',
	flexWrap: 'nowrap',
	alignItems: 'center',
	gap: `${COLOR_DOT_GAP}px`,
};

export const colorDotButtonSX = (isSelected: boolean): SxProps<Theme> => ({
	width: `${COLOR_DOT_SIZE}px`,
	height: `${COLOR_DOT_SIZE}px`,
	borderRadius: '50%',
	border: '0.6px solid',
	borderColor: isSelected ? '#000000' : 'transparent',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
});

export const colorDotInnerSX: SxProps<Theme> = {
	width: `${COLOR_DOT_INNER_SIZE}px`,
	height: `${COLOR_DOT_INNER_SIZE}px`,
	borderRadius: '50%',
	border: '1px solid #E0E0E0',
	overflow: 'hidden',
	position: 'relative',
};

export const colorOverflowButtonSX: SxProps<Theme> = {
	width: `${COLOR_DOT_SIZE}px`,
	height: `${COLOR_DOT_SIZE}px`,
	borderRadius: '50%',
	border: '0.6px solid transparent',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
};

export const colorOverflowInnerSX: SxProps<Theme> = {
	width: `${COLOR_DOT_INNER_SIZE}px`,
	height: `${COLOR_DOT_INNER_SIZE}px`,
	borderRadius: '50%',
	border: '1px solid #E0E0E0',
	background: '#F5F5F5',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

export const colorOverflowLabelSX: SxProps<Theme> = {
	fontSize: '12px',
	fontWeight: '600',
	color: '#2C2C2C',
	lineHeight: 1,
	'&:hover': {
		textDecoration: 'underline',
	},
};
